module.exports = "/images/yd-icon.svg?7132bc2b1dd26d97163b513420e6da8c";


//////////////////
// WEBPACK FOOTER
// ./resources/images/speedtest-result/yd-icon.svg
// module id = 0PRi
// module chunks = 7 182